export default class BillingPriceMetadata {
  public quota: undefined | number = undefined;
  public overageUnitAmount: undefined | number = undefined;
  public smsUnitAmount: undefined | number = undefined;
  public quotaRenewal: undefined | 'month' | 'year' = undefined;
  public kind: undefined | number = undefined;

  constructor(options) {
    if (options.quota) {
      this.quota = parseInt(options.quota, 10);
    }
    if (options.quotaRenewal) {
      this.quotaRenewal = options.quotaRenewal;
    }
    if (options.smsUnitAmount) {
      this.smsUnitAmount = parseInt(options.smsUnitAmount, 10);
    }
    if (options.overageUnitAmount) {
      this.overageUnitAmount = parseInt(options.overageUnitAmount, 10);
    }
    if (options.kind) {
      this.kind = parseInt(options.kind, 10);
    }
  }

  public complete() {
    if (this.quotaRenewal && this.smsUnitAmount && this.kind) return true;

    return false;
  }

  public completePayg(): boolean {
    if (this.smsUnitAmount && (typeof this.kind === 'number' && this.kind > 0)) return true;

    return false;
  }

  public completeLicensed(): boolean {
    if (this.smsUnitAmount
        && (typeof this.kind === 'number' && this.kind > 0)
        && this.quota
        && this.quotaRenewal
        && this.overageUnitAmount) {
      return true;
    }

    return false;
  }
}
